import { render, staticRenderFns } from "./RestaurantDashboardPage.vue?vue&type=template&id=1379097a&scoped=true&"
import script from "./RestaurantDashboardPage.vue?vue&type=script&lang=js&"
export * from "./RestaurantDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDashboardPage.vue?vue&type=style&index=0&id=1379097a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379097a",
  null
  
)

export default component.exports